import { useState, type ReactNode } from 'react';
import { Link, useLocation } from 'wouter';
import { navItems } from '../data/site';

export function Brand() {
  return <Link href="/" className="brand" aria-label="SYPP home">
    <span className="brand-mark">SYPP</span>
    <span className="brand-copy">Student Yellow Pages Pakistan<small>Search. Study. Work. Grow.</small></span>
  </Link>;
}

export function Header() {
  const [open, setOpen] = useState(false);
  const [location] = useLocation();
  return <>
    <div className="announcement"><strong>SYPP is being built for students across Pakistan</strong> — Early Access</div>
    <header className="topbar">
      <div className="container nav-wrap">
        <Brand />
        <nav className="nav-links" aria-label="Main navigation">
          {navItems.map((item) => <Link key={item.href} href={item.href} aria-current={location === item.href ? 'page' : undefined}>{item.label}</Link>)}
        </nav>
        <Link href="/get-listed" className="nav-cta">List / Submit <span aria-hidden="true">→</span></Link>
        <button className="menu-toggle" type="button" aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open} onClick={() => setOpen(!open)}>{open ? 'Close' : 'Menu'}</button>
      </div>
      {open && <nav className="mobile-panel nav-mobile" aria-label="Mobile navigation">
        {[...navItems, { label: 'Sponsors & Partners', href: '/partners' }, { label: 'Get Listed', href: '/get-listed' }, { label: 'Contact', href: '/contact' }].map((item) => <Link key={item.href} href={item.href} onClick={() => setOpen(false)}>{item.label}</Link>)}
      </nav>}
    </header>
  </>;
}

export function Footer() {
  const links = [
    ['Hostels', '/hostels'], ['Scholarships', '/scholarships'], ['Jobs', '/jobs'], ['Study Abroad', '/study-abroad'],
    ['Universities', '/universities'], ['Student Services', '/student-services'], ['About', '/about'], ['Sponsors & Partners', '/partners'],
    ['Contact', '/contact'], ['Privacy', '/privacy'], ['Terms', '/terms'], ['Disclaimer', '/disclaimer'], ['Report information', '/report'],
  ];
  return <footer className="footer">
    <div className="container">
      <div className="footer-grid">
        <div><Brand /><p>Everything Students Need.<br />A discovery and opportunity platform being developed for students across Pakistan.</p><span className="sponsor-line">Sponsored by Oranexa Ventures Pakistan</span></div>
        <div><h3>Explore SYPP</h3><div className="footer-links">{links.slice(0, 8).map(([label, href]) => <Link href={href} key={href}>{label}</Link>)}</div></div>
        <div><h3>Useful links</h3><div className="footer-links">{links.slice(8).map(([label, href]) => <Link href={href} key={href}>{label}</Link>)}<Link href="/get-listed">List / Submit</Link></div></div>
      </div>
      <div className="footer-bottom"><span>© {new Date().getFullYear()} SYPP — Student Yellow Pages Pakistan. All rights reserved.</span><span>Early-stage platform. Sample content is labelled.</span></div>
    </div>
  </footer>;
}

export function PageLayout({ children }: { children: ReactNode }) {
  return <div className="site-shell"><Header /><main>{children}</main><Footer /></div>;
}
